import { useState } from "react"
import GiscoAutocomplete from "../../../components/GiscoAutocomplete"
import { Event2LocationPost } from "../../../models/Event"
import Feature from "../../../models/GISCO/Feature"

// #region Type Declaration

type Event2LocationProps = {
    onSuccess: (location: Event2LocationPost) => void
}

// #endregion

const Event2Location = ({ onSuccess }: Event2LocationProps) => {

    // #region Init States

    let initLocation: Event2LocationPost = {
        osmid           : -1,
        name            : "",
        city            : "",
        countryISO_3166 : "",
        latitude        : 0,
        longitude       : 0
    }

    // #endregion

    // #region State & Hooks

    const [show, setShow] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);

    const [location, setLocation] = useState<Event2LocationPost>(initLocation);

    // #endregion

    /**
     * Method renders alert with missing mandatory field informations.
     * TO-DO: Extract in on components that takes an array with errors as parameter.
     * @returns JSX.Element representing a boostrap alert alert-danger.
     */
    const renderErrorPane = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-danger">
                        <p className="fw-bold mb-0">Whoops! There were some problems with your input.</p>
                        <ul className="mb-0">
                            {
                                errors.map((value, index) => {
                                    return (
                                        <li key={"err_" + index}>{value}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * ...
     * @param feature
     */
    const onAutoCompleteChange = (feature: Feature) => {

        setLocation({
            osmid           : feature.properties.osm_id,
            name            : feature.properties.type === "house" && feature.properties.name ? feature.properties.name : location.name,
            city            : feature.properties.type === "city"  && feature.properties.name ? feature.properties.name : feature.properties.city,
            countryISO_3166 : feature.properties.countrycode,
            latitude        : feature.geometry.coordinates[1],
            longitude       : feature.geometry.coordinates[0]
        })
    }

    /**
     *  ...
     */
    const onSubmit = () => {

        // #region Validation

        let errors: string[] = [];

        if (location.name === '')            { errors.push("Field 'Venue Name' is required.") }
        if (location.city === '')            { errors.push("Field 'City' is required.") }
        if (location.countryISO_3166 === '') { errors.push("Field 'Country' is required.") }

        // #endregion

        if (errors.length === 0)
        {
            setShow(false);
            onSuccess(location);
        }
        else { setErrors(errors); }
    }

    return (

        <>
            <button className="btn btn-success" onClick={e => setShow(true)}>
                <i className="bi bi-plus-lg"></i>
            </button>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-body">

                            {(errors.length > 0) && renderErrorPane()}

                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info" role="alert">
                                        <i className="bi bi-info-circle me-2" />
                                        Please select the venue from the GISCO suggestion list. Select either the <b>institution</b> or the <b>city</b> of the conference.
                                    </div>
                                </div>
                            </div>

                            <div className="row">

                                <div className="form-group col-12">
                                    <label htmlFor="sourceLocation" className="fw-bold">Institution | City</label>
                                    <GiscoAutocomplete id="sourceLocation" onFeatureChange={onAutoCompleteChange} />
                                </div>

                                <div className="form-group col-12 col-md-6">
                                    <label htmlFor="venueName" className="fw-bold">Venue Name</label>
                                    <input type="text" id="venueName" className="form-control" value={location.name} onChange={e => setLocation(x => ({ ...x, name: e.target.value }))} />
                                </div>

                                <div className="form-group col-12 col-md-6">
                                    <label htmlFor="city" className="fw-bold">City</label>
                                    <input type="text" id="city" className="form-control" disabled={true} value={location.city} />
                                </div>

                            </div>

                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" onClick={e => setShow(false)}>
                                <i className="bi bi-x-lg" />
                            </button>
                            <button className="btn btn-success" onClick={onSubmit}>
                                <i className="bi bi-plus-lg"></i>
                            </button>
                        </div>

                    </div>
                </div>
            </div> 

        </>

    );
}
export default Event2Location;